import { render, staticRenderFns } from "./baseStaffRecordDetail.vue?vue&type=template&id=0c826448"
import script from "./baseStaffRecordDetail.vue?vue&type=script&lang=js"
export * from "./baseStaffRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./baseStaffRecordDetail.vue?vue&type=style&index=0&id=0c826448&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c826448')) {
      api.createRecord('0c826448', component.options)
    } else {
      api.reload('0c826448', component.options)
    }
    module.hot.accept("./baseStaffRecordDetail.vue?vue&type=template&id=0c826448", function () {
      api.rerender('0c826448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hireManagement/components/baseStaffRecordDetail.vue"
export default component.exports